import { FC } from 'react'
import styles from 'components/features/coaching/advisor/AdvisorRating/AdvisorRating.styl'
import { Advisor } from 'components/features/coaching/advisor/types/advisor'
import { StarsRow } from 'components/features/coaching/advisorPublicPage/StarsRow/StarsRow'

type AdvisorRatingProps = {
  advisor: Advisor
}
export const AdvisorRating: FC<AdvisorRatingProps> = (props) => {
  const { advisor } = props

  return (
    <div className={ styles.advisorRating }>
      { (+advisor.rating).toFixed(1) }
      <div className={ styles.stars }>
        <StarsRow size={ 12 } rating={ +advisor.rating } />
      </div>
    </div>
  )
}
